import { Injectable, inject } from "@angular/core";

import {
    ApplicationInsightsServiceExt,
    IApplicationInsighsTracer
} from "./application-insights.service";

@Injectable({ providedIn: "root" })
export class EventsTrackerProvider {
    private _eventTracer = inject(ApplicationInsightsServiceExt);

    public get _current(): IApplicationInsighsTracer {
        return this._eventTracer;
    }

    _trackFlagChangedEvent(categoryNameLc: string, flag: string, rowCode?: number | string): void {
        this._eventTracer.trackEvent(categoryNameLc, "FlagsChecked", flag, rowCode);
    }

    _trackRowClicked(categoryNameLc: string, label: string, rowCode?: unknown): void {
        const rowValue =
            typeof rowCode === "string" || typeof rowCode === "number"
                ? rowCode
                : JSON.stringify(rowCode);
        this._eventTracer.trackEvent(categoryNameLc, "Clicked", label, rowValue);
    }

    _trackDialogOpened(label: string): void {
        this._eventTracer.trackEvent("Dialogs", "Opened", label);
    }

    _trackException(error: Error): void {
        this._eventTracer.trackException(error);
    }
}
